import React, { lazy } from 'react';
import { Quote, Star } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'En 3 semanas mis ataques bajaron de 4 a 1 por mes.',
  author: 'Claudia',
  age: '34',
  location: 'CDMX',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Al tercer día mi esposo notó que estaba diferente.',
  author: 'María',
  age: '42',
  location: 'Sevilla',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Dejé las pastillas para dormir en la primera semana.',
  author: 'Lucía',
  age: '29',
  location: 'Buenos Aires',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'No tengo 30 minutos para meditar. Pero 5 sí.',
  author: 'Andrea',
  age: '37',
  location: 'Bogotá',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Mi ansiedad bajó en la primera semana.',
  author: 'Valentina',
  age: '31',
  location: 'Lima',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Por fin pude dormir sin despertarme a las 3am.',
  author: 'Sofía',
  age: '38',
  location: 'Madrid',
  avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face'
}];
function StarRow() {
  return <div className="flex gap-0.5" data-id="element-302">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="h-4 w-4 fill-[#C4973B] text-[#C4973B]" data-id="element-303" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-20 bg-[#C06B6B] px-4" data-id="element-304">
      <div className="max-w-6xl mx-auto" data-id="element-305">
        <div className="text-center mb-12" data-id="element-306">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-307">
            Resultados reales
          </h2>
        </div>

        {/* Visual proof bar */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12" data-id="element-308">
          <div className="bg-white rounded-2xl p-6 shadow-lg flex flex-col justify-center" data-id="element-309">
            <div className="flex items-center gap-2 mb-3" data-id="element-310">
              <div className="w-8 h-8 bg-[#FF6B35] rounded-lg flex items-center justify-center" data-id="element-311">
                <span className="text-white text-xs font-bold" data-id="element-312">H</span>
              </div>
              <span className="text-sm font-bold text-gray-700" data-id="element-313">Hotmart</span>
              <span className="ml-auto text-xs bg-green-50 text-green-700 px-2 py-0.5 rounded-full font-medium" data-id="element-314">
                Verificado
              </span>
            </div>
            <div className="flex items-end gap-2 mb-1" data-id="element-315">
              <span className="text-4xl font-bold text-gray-900" data-id="element-316">4.9</span>
              <span className="text-gray-400 text-sm mb-1" data-id="element-317">/ 5</span>
            </div>
            <StarRow data-id="element-318" />
            <p className="text-xs text-gray-500 mt-2" data-id="element-319">
              Basado en +2,400 compradoras
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg col-span-1 md:col-span-2" data-id="element-320">
            <p className="text-sm font-bold text-gray-700 mb-4" data-id="element-321">
              Distribución de valoraciones
            </p>
            <div className="space-y-2" data-id="element-322">
              {[{
              stars: 5,
              pct: 87
            }, {
              stars: 4,
              pct: 9
            }, {
              stars: 3,
              pct: 3
            }, {
              stars: 2,
              pct: 1
            }, {
              stars: 1,
              pct: 0
            }].map(({
              stars,
              pct
            }) => <div key={stars} className="flex items-center gap-3" data-id="element-323">
                  <span className="text-xs text-gray-500 w-4 text-right" data-id="element-324">
                    {stars}
                  </span>
                  <Star className="h-3 w-3 fill-[#C4973B] text-[#C4973B] flex-shrink-0" data-id="element-325" />
                  <div className="flex-1 bg-gray-100 rounded-full h-2 overflow-hidden" data-id="element-326">
                    <div className="bg-[#C4973B] h-2 rounded-full" style={{
                  width: `${pct}%`
                }} data-id="element-327" />
                  </div>
                  <span className="text-xs text-gray-400 w-8" data-id="element-328">{pct}%</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Testimonial cards — compact */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-329">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-3 rounded-xl shadow-md" data-id="element-330">
              <div className="flex items-center gap-2 mb-2" data-id="element-331">
                <img src={t.avatar} alt={t.author} className="w-8 h-8 rounded-full object-cover ring-1 ring-[#C4973B]/30" loading="lazy" data-id="element-332" />
                <div className="min-w-0" data-id="element-333">
                  <p className="font-bold text-gray-900 text-xs truncate" data-id="element-334">
                    {t.author}, {t.age}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-335">
                    {t.location} · ✓ Verificada
                  </p>
                </div>
              </div>
              <p className="text-gray-700 text-xs leading-snug" data-id="element-336">"{t.quote}"</p>
            </div>)}
        </div>
      </div>
    </section>;
}